import React, { useCallback, useEffect } from 'react'

import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import { Stack } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Features } from 'generated/featureDefinitions'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import { useActivities } from 'modules/core/lib/activities/provider'

import { TicketList } from 'modules/ticketing/components/TicketList/TicketList'
import { type TicketNode } from 'modules/ticketing/components/TicketList/ticketListConfig'
import { trackGoToTicketing } from 'modules/ticketing/lib/tracking'

const TicketListPage: React.FC = () => {
  const { openActivity } = useActivities()

  const { has_dev_ai_ticketing_core, loadingFeatures } = useFeatures([
    Features.dev_ai_ticketing_core,
  ])

  useEffect(() => {
    trackGoToTicketing()
  }, [])

  const openTicketDetail = useCallback(
    (item: TicketNode) => {
      openActivity('ticketing.viewTicket', { ticketId: String(item.id) })
    },
    [openActivity]
  )

  const handleOpenCreateDialog = useCallback(() => {
    openActivity('ticketing.createTicket')
  }, [openActivity])

  return (
    <>
      <ResponsivePage.Body
        variant="fullscreen"
        height="full"
        loading={loadingFeatures}
        authorized={has_dev_ai_ticketing_core}
        error={undefined}
      >
        {!loadingFeatures && !has_dev_ai_ticketing_core ? (
          <Stack gap="4" paddingY="p-4">
            <OneEmptyState
              title={i18n.t('ticketing.inbox.no_access_title')}
              description={i18n.t('ticketing.inbox.no_access_description')}
            />
          </Stack>
        ) : (
          <Stack gap="4" paddingY="p-4">
            <TicketList
              onOpenCreateDialog={handleOpenCreateDialog}
              onItemClick={openTicketDetail}
            />
          </Stack>
        )}
      </ResponsivePage.Body>
    </>
  )
}

export default TicketListPage
